<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Plan</label>
            <input class="form-control" v-model="value.NetsisAccountCode" placeholder="Plan"/>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Borç/Alacak</label>
            <v-select-list :options="baTypes" label="name" placeholder="Borç/Alacak" v-model="baType"></v-select-list>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Proje Kodu</label>
            <v-select-list :options="projectCodes" label="name" placeholder="Proje Kodu" v-model="projectCode"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yansıtma Merkezi</label>
            <v-select-list :options="yansitmas" label="Name" placeholder="Yansıtma Merkezi" v-model="yansitma"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Yaka</label>
            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            baTypes:[
                {name:'Borç',value:'B'},
                {name:'Alacak',value:'A'},
            ],
            projectCodes:[
                {name:'G',value:'G'},
                {name:'R',value:'R'},
            ],
            yansitmas:[],
            collarStatuses:[]
        }
    },
    mounted(){
        this.getYansitmas()
        this.getCollarStatuses()
        this.getCollarStatuses()
    },
    methods:{
        getYansitmas(){
            SystemDataApi.TrafikCezasiYansitmaMerkeziType().then(res => {
                this.yansitmas = res.data.Data || []
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
    },
    computed:{
        baType:{
            get:function(){
                return this.baTypes.find(b=>b.value==this.value.B_A)
            },
            set:function(value){
                this.value.B_A = value?.value || null
            }
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(b=>b.value==this.value.G_R)
            },
            set:function(value){
                this.value.G_R = value?.value || null
            }
        },
        yansitma:{
            get:function(){
                return this.yansitmas.find(b=>b.Value == this.value.NetsisTrafikCezasiYansitmaMerkeziType)
            },
            set:function(value){
                this.value.NetsisTrafikCezasiYansitmaMerkeziType = value?.Value ?? null
            }
        },
        collarStatus:{
            get:function(){
                return this.collarStatuses.find(m=>m.Id==this.value.CollarStatusId)
            },
            set:function(value){
                this.value.CollarStatusId = value?.Id || null
            }
        },
    }
}
</script>